module.exports = {
    download_title: '讓財富近在咫尺',
    download_description: '你需要的一切都在UPlus 應用程序中',
    download_robot: '全自動量化交易機器人',
    download_trusted: '百萬加密貨幣投資者的信賴',
    ios_profile_download:'iOS 描述檔下載'

}